import styled, { css } from 'styled-components'

import ActionButton from '../ActionButton'
import Link from '../Link'
import Icon from '../Icon'

export const Banner = styled.div`
  padding: 3rem;
  background-color: ${({ theme }) => theme.colors.bluePrimary};
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-around;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    flex-direction: column;
    align-items: center;
    gap: 3rem;
  }
`

export const Block = styled.div`
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  max-width: 45rem;
  width: 100%;
`

export const Title = styled.p<{ $centered?: boolean }>`
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
  color: ${({ theme }) => theme.colors.pureWhite};
  white-space: pre-wrap;

  ${({ $centered }) =>
    $centered &&
    css`
      text-align: center;
    `};
`

export const SubTitle = styled.p`
  ${({ theme }) => theme.textStyles.firaSansXl};
  color: ${({ theme }) => theme.colors.pureWhite};
  margin-bottom: 3.4rem;
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.montserratSm};
  color: ${({ theme }) => theme.colors.pureWhite};
  white-space: pre-wrap;
  margin-top: 2.9rem;
`

export const EcpsConnectionIssueLink = styled(Link)`
  margin-top: 3.5rem;
  text-decoration: underline;
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.pureWhite};
`

export const Content = styled.div`
  max-width: 52rem;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
`

export const Button = styled(ActionButton)`
  min-width: 11rem;
  white-space: nowrap;
`

export const LeftBlockButton = styled(ActionButton)`
  min-width: 11rem;
  white-space: nowrap;
  margin-top: 0.5rem;
`

export const _Link = styled(Link)`
  align-self: flex-start;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.pureWhite};
  margin-top: 3rem;
`

export const BackLinkIcon = styled(Icon)`
  margin-right: 1rem;
`
